// Curated, business-grade Hindi translations (no machine-literal style).
export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      projects: 'Projects',
      plots: 'Plots',
      houses: 'Houses',
      commercial: 'Commercial',
      farmhouse: 'Farmhouse',
      contact: 'Contact',
      careers: 'Careers',
      tools: 'Tools',
      blog: 'Blog',
      land_converter: 'Land Size Converter',
      loan_calculator: 'Loan Calculator',
    },
    cta: {
      enquire_now: 'Enquire Now',
      book_visit: 'Book a Visit',
      view_details: 'View Details',
      view_all: 'View All',
      explore: 'Explore Plots & Houses',
      call_now: 'Call Now',
      whatsapp: 'WhatsApp',
      share: 'Share',
      download_brochure: 'Download Brochure',
      submit: 'Submit',
      submit_enquiry: 'Submit Enquiry',
    },
    common: {
      price_on_request: 'Price on Request',
      contact_for_details: 'Contact for Details',
      featured: 'Featured',
      explore_categories: 'Explore Our Properties',
      featured_properties: 'Featured Properties',
      hand_picked: 'Hand-picked properties for you',
      why_choose: 'Why Choose Shree Bajrang Developers',
      ready_to_find: 'Ready to Find Your Dream Property?',
      free_consultation: 'Free consultation',
      no_obligation: 'No obligation site visits',
      rera_registered: 'RERA Registered',
      filters: 'Filters',
      apply_filters: 'Apply Filters',
      reset: 'Reset',
      no_properties: 'No properties found',
      loading: 'Loading...',
      related_properties: 'Related Properties',
      property_details: 'Property Details',
      amenities: 'Amenities',
      location: 'Location',
      description: 'Description',
      gallery: 'Gallery',
      videos: 'Videos',
      brochure: 'Brochure',
      total_price: 'Total Price',
      price_per_sqft: 'Price / sq ft',
      area: 'Area',
      facing: 'Facing',
      possession: 'Possession',
      bhk: 'Configuration',
      government_value: 'Government Value',
    },
    form: {
      name: 'Name',
      mobile: 'Mobile',
      email: 'Email',
      message: 'Message',
      property_type: 'Property Type',
      preferred_location: 'Preferred Location',
      preferred_date: 'Preferred Date',
      preferred_time: 'Preferred Time',
      required: 'Required',
      submitted: 'Thank you! We will contact you soon.',
      brochure_inquiry_title: 'Get Free Brochure',
      brochure_inquiry_subtitle: 'Fill the form to instantly download the brochure',
    },
    share: {
      title: 'Share this property',
      copy_link: 'Copy Link',
      whatsapp: 'Share on WhatsApp',
      copied: 'Link copied!',
    },
  },
  hi: {
    nav: {
      home: 'होम',
      about: 'हमारे बारे में',
      projects: 'प्रोजेक्ट्स',
      plots: 'प्लॉट्स',
      houses: 'घर',
      commercial: 'कमर्शियल',
      farmhouse: 'फार्महाउस',
      contact: 'संपर्क',
      careers: 'करियर',
      tools: 'टूल्स',
      blog: 'ब्लॉग',
      land_converter: 'भूमि माप कैलकुलेटर',
      loan_calculator: 'लोन कैलकुलेटर',
    },
    cta: {
      enquire_now: 'अभी पूछताछ करें',
      book_visit: 'विज़िट बुक करें',
      view_details: 'विवरण देखें',
      view_all: 'सभी देखें',
      explore: 'प्लॉट्स और घर देखें',
      call_now: 'कॉल करें',
      whatsapp: 'व्हाट्सएप',
      share: 'शेयर करें',
      download_brochure: 'ब्रोशर डाउनलोड करें',
      submit: 'भेजें',
      submit_enquiry: 'पूछताछ भेजें',
    },
    common: {
      price_on_request: 'कीमत के लिए संपर्क करें',
      contact_for_details: 'विवरण के लिए संपर्क करें',
      featured: 'फीचर्ड',
      explore_categories: 'हमारी प्रॉपर्टीज़ देखें',
      featured_properties: 'फीचर्ड प्रॉपर्टीज़',
      hand_picked: 'आपके लिए चुनी गई बेहतरीन प्रॉपर्टीज़',
      why_choose: 'श्री बजरंग डेवलपर्स को क्यों चुनें',
      ready_to_find: 'अपनी ड्रीम प्रॉपर्टी खोजने के लिए तैयार हैं?',
      free_consultation: 'निःशुल्क सलाह',
      no_obligation: 'बिना किसी बाध्यता के साइट विज़िट',
      rera_registered: 'RERA पंजीकृत',
      filters: 'फ़िल्टर',
      apply_filters: 'फ़िल्टर लगाएं',
      reset: 'रीसेट',
      no_properties: 'कोई प्रॉपर्टी नहीं मिली',
      loading: 'लोड हो रहा है...',
      related_properties: 'मिलती-जुलती प्रॉपर्टीज़',
      property_details: 'प्रॉपर्टी विवरण',
      amenities: 'सुविधाएं',
      location: 'स्थान',
      description: 'विवरण',
      gallery: 'गैलरी',
      videos: 'वीडियो',
      brochure: 'ब्रोशर',
      total_price: 'कुल कीमत',
      price_per_sqft: 'कीमत प्रति वर्ग फुट',
      area: 'क्षेत्रफल',
      facing: 'दिशा',
      possession: 'पजेशन',
      bhk: 'BHK',
      government_value: 'सरकारी मूल्य',
    },
    form: {
      name: 'नाम',
      mobile: 'मोबाइल',
      email: 'ईमेल',
      message: 'संदेश',
      property_type: 'प्रॉपर्टी प्रकार',
      preferred_location: 'पसंदीदा स्थान',
      preferred_date: 'पसंदीदा तारीख',
      preferred_time: 'पसंदीदा समय',
      required: 'आवश्यक',
      submitted: 'धन्यवाद! हम जल्द ही आपसे संपर्क करेंगे।',
      brochure_inquiry_title: 'मुफ़्त ब्रोशर पाएं',
      brochure_inquiry_subtitle: 'ब्रोशर तुरंत डाउनलोड करने के लिए फॉर्म भरें',
    },
    share: {
      title: 'इस प्रॉपर्टी को शेयर करें',
      copy_link: 'लिंक कॉपी करें',
      whatsapp: 'व्हाट्सएप पर शेयर करें',
      copied: 'लिंक कॉपी हो गया!',
    },
  },
};
